import { pageViewTypes } from "@constants/tracking";
import {
	FeedbackForm,
	defaultFeedbackSubtitle,
	dialogTexts,
} from "@features/feedback";
import type { FeedbackType } from "@features/feedback/helpers";
import useAnalytics from "@hooks/useAnalytics";
/* -----------------Child components--------------- */
import { Box } from "@memorang/ui";
import ModalHeader from "components/ModalHeader";
/* -----------------Globals--------------- */
import { Stack, useLocalSearchParams, useRouter } from "expo-router";
import { useTranslation } from "react-i18next";

const FeedbackRoute = () => {
	useAnalytics({
		type: pageViewTypes.feedback,
	});

	const {
		view,
		itemId,
		sessionId,
		threadId,
		runId,
		featureName,
		itemFeedbackRating,
		type,
		sessionType,
		responseId,
		context,
		feedbackTitle,
		feedbackSubtitle,
		feedbackCta,
	} = useLocalSearchParams<{
		view?: string;
		itemId?: string;
		sessionId?: string;
		threadId?: string;
		runId?: string;
		featureName?: string;
		itemFeedbackRating?: string;
		type?: string;
		sessionType?: string;
		responseId?: string;
		context?: string;
		feedbackTitle?: string;
		feedbackSubtitle?: string;
		feedbackCta?: string;
	}>();
	const router = useRouter();
	const config = dialogTexts.feedback;
	const { t } = useTranslation();

	const handleDismissFeedback = () => {
		router.back();
	};
	const parsedSessionId = Number(sessionId);
	// URL params are arbitrary strings; only pass through known values.
	const validatedType: FeedbackType | undefined =
		type === "Review" || type === "Deletion" || type === "Content Flagged"
			? type
			: undefined;
	return (
		<>
			<Stack.Screen
				options={{
					presentation: "modal",
					headerShown: true,
					header: () => (
						<ModalHeader
							backIcon="arrow-left"
							headerTitle={feedbackTitle || t(config.title)}
						/>
					),
				}}
			/>
			<Box padding={16}>
				<FeedbackForm
					view={view || "profile"}
					handleDismiss={handleDismissFeedback}
					feedbackSubtitle={feedbackSubtitle || t(defaultFeedbackSubtitle)}
					feedbackCta={feedbackCta}
					itemId={itemId}
					sessionId={
						Number.isNaN(parsedSessionId) ? undefined : parsedSessionId
					}
					threadId={threadId}
					runId={runId}
					featureName={featureName}
					itemFeedbackRating={
						itemFeedbackRating === "positive" ||
						itemFeedbackRating === "negative"
							? itemFeedbackRating
							: undefined
					}
					type={validatedType}
					sessionType={sessionType}
					responseId={responseId}
					context={context}
				/>
			</Box>
		</>
	);
};

export default FeedbackRoute;
